import React from "react";
import { useSelector, useDispatch } from "react-redux";

const TractionAICompanySnapshot = () => {
  const dispatch = useDispatch();

  return (
    <div className="mt-4">
      <h4>Create a Company Snapshot</h4>
    </div>
  );
};

export default React.memo(TractionAICompanySnapshot);
